import React from 'react';
import { Button, ButtonColor, ButtonSize, useShowContextRequired } from 'ui-builder';
import { Plan } from 'nekst-api';
import { InformationMessage, usePopupFormManager } from 'features/nekst-widgets';
import { CopyPlanForm } from 'features/tasks-forms';
import usePlansNavigator from '../plansNavigator';

import styles from './DefaultPlanHelper.module.scss';

function CopyButton(
  props: {
    id: number
  }
) {
  const popupFormManager = usePopupFormManager();

  const plansNavigator = usePlansNavigator()

  return (
    <Button
      text="Copy Workflow"
      onClick={() => {
        popupFormManager.openForm(<CopyPlanForm
          id={props.id}
          afterSubmitFunc={async (plan) => plansNavigator.openPlanPage(plan.id)}
        />)
      }}
      size={ButtonSize.MEDIUM}
      color={ButtonColor.BLUE}
      isFilled
    />
  )
}

export default function DefaultPlanHelper() {
  const showContext = useShowContextRequired<Plan>();

  if (showContext.data!.isGlobal) {
    return (
      <InformationMessage className={styles.box}>
        To Modify this Workflow, First Make a Copy
        {' '}
        <CopyButton id={showContext.data!.id} />
      </InformationMessage>
    );
  } else {
    return null;
  }
}
